import type { IntercomCommand, IntercomUpdateData } from './help-center.types'

class HelpCenter {
  private execute(command: IntercomCommand, ...args: any[]) {
    const globalWindow = window as any
    const isBooted = globalWindow?.Intercom?.booted

    if (isBooted) {
      globalWindow.Intercom(command, ...args)
      return
    }
  }

  update(data: IntercomUpdateData) {
    this.execute('update', data)
  }

  showNewMessage(message?: string) {
    this.execute('showNewMessage', message)
  }

  init() {
    /* Hides the default launcher button. */
    this.update({ hide_default_launcher: true })
  }

  get booted(): boolean {
    const globalWindow = window as any
    return globalWindow?.Intercom?.booted
  }
}

export const helpCenter = new HelpCenter()
